import {
  CuriosityAutocompleteProps,
  CuriosityNamespaceType,
  CuriosityAutocomplete,
  CuriosityNamespace,
  CuriosityAutocompleteValueWithNull,
} from '@procureai/curiosity-ui-mui';
import { ForwardedRef, forwardRef } from 'react';

import { SupplierLocationEntity } from './SupplierLocationAutocomplete.types';

export type SupplierLocationAutocompleteProps<
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  Ns extends CuriosityNamespace = CuriosityNamespace,
> = Omit<CuriosityAutocompleteProps<SupplierLocationEntity, Multiple, DisableClearable, Ns>, 'ns'>;

const SupplierLocationAutocompleteInner = <
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  Ns extends CuriosityNamespace = CuriosityNamespace,
>(
  { ...props }: SupplierLocationAutocompleteProps<Multiple, DisableClearable, Ns>,
  ref: ForwardedRef<unknown>,
) => {
  return (
    <CuriosityAutocomplete<SupplierLocationEntity, Multiple, DisableClearable>
      ref={ref}
      ns={CuriosityNamespaceType.SUPPLIER_LOCATION}
      {...props}
      onChange={(val) => {
        if (props.onChange) {
          const nextArr: CuriosityAutocompleteValueWithNull<SupplierLocationEntity> = props.multiple
            ? (val as any)
            : [val];
          props.onChange(props.multiple ? (nextArr as any) : nextArr[0]);
        }
      }}
    />
  );
};

export const SupplierLocationAutocomplete = forwardRef(SupplierLocationAutocompleteInner) as <
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  Ns extends CuriosityNamespace = CuriosityNamespace,
>(
  props: SupplierLocationAutocompleteProps<Multiple, DisableClearable, Ns> & {
    ref?: ForwardedRef<unknown>;
  },
) => ReturnType<typeof SupplierLocationAutocompleteInner>;
